import React, { useEffect, useState, ChangeEvent } from 'react';
import { Card, Col, Row } from 'antd';
import { Widget, addResponseMessage, toggleWidget, addUserMessage, isWidgetOpened } from 'react-chat-widget';
import './home.scss';

export const Home: React.FC = () => {
    const [isOpenChat, setIsOpenChat] = useState(false);
    const [questionMsg, setQuestionMsg] = useState('');
    const handleNewUserMessage = (newMessage: string) => {
        console.log(`New message incoming! ${newMessage}`);
        // Now send the message throught the backend API
        addResponseMessage('response');
        console.log(isWidgetOpened())
    };
    useEffect(() => {
        addResponseMessage('Welcome to this awesome chat!');
        // toggleWidget()
    }, []);

    useEffect(() => {
        document.getElementsByClassName('rcw-widget-container')[0]?.addEventListener('click', () => {
            requestAnimationFrame(() => {
                setIsOpenChat(isWidgetOpened());
            })
        }, false);
    }, [])

    // const getCustomLauncher = (handleToggle: any) => {
    //     return (
    //         <div style={{border: '1px solid red'}}> 
    //             <button onClick={() => {
    //                 addResponseMessage('Welcome to this **awesome** chat!');
    //                 alert()
    //                 handleToggle()
    //             }}>This is my launcher component!</button>
    //         </div>)
    // }

    return (
        <div className='home-container'>
            <div className='home-title'>
                ChatGPT 如果没有答案，多试几次
            </div>
            <div className='home-box'>
                <textarea
                    style={{ zIndex: isOpenChat ? 'auto' : 10000 }}
                    value={questionMsg}
                    className='home-input-textarea'
                    placeholder='Write a test message....'
                    onChange={(e: ChangeEvent) => {
                        setQuestionMsg((e.target as any).value as string)
                    }}
                ></textarea>
                <button
                    style={{ zIndex: isOpenChat ? 'auto' : 10000 }}
                    className='home-send-btn'
                    onClick={() => {
                        questionMsg && addUserMessage(questionMsg);
                        !isWidgetOpened() && toggleWidget()
                        requestAnimationFrame(() => {
                            setIsOpenChat(isWidgetOpened());
                        })
                    }}>
                    Send Message!
                </button>
            </div>

            <div className="home-features">
                <Row gutter={16}>
                    <Col span={8}>
                        <div className='home-card'>
                            <div className='card-title'>
                                问题示例
                            </div>
                            <div className='card-item'>
                                "用简单的术语解释量子计算"
                            </div>
                            <div className='card-item'>
                                "准备为10岁的孩子过生日，有什么创意的想法吗"
                            </div>
                            <div className='card-item'>
                                "如何用 JavaScript 发送 HTTP 请求"
                            </div>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div className='home-card'>
                            <div className='card-title'>
                                功能
                            </div>
                            <div className='card-item'>
                                记住用户在对话中早些时候说的话
                            </div>
                            <div className='card-item'>
                                允许用户在下文提供后续内容的更正
                            </div>
                            <div className='card-item'>
                                接受过专业的语言训练，会合理拒绝不正当的请求
                            </div>
                        </div>
                    </Col>
                    <Col span={8}>
                        <div className='home-card'>
                            <div className='card-title'>
                                限制
                            </div>
                            <div className='card-item'>
                                可能会产生不准确的信息
                            </div>
                            <div className='card-item'>
                                可能会产生带有偏见或违反安全准则的内容
                            </div>
                            <div className='card-item'>
                                对2021年以后的世界了解有限。
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <div>
                <Widget
                    showCloseButton={true}
                    fullScreenMode={isOpenChat}
                    handleToggle={(status: boolean) => {
                        alert()
                        console.log(status)
                    }}
                    title="ChatGPT"
                    subtitle="You can ask any question you want"
                    senderPlaceHolder="Type a message..."
                    // launcher={(handleToggle: any) => getCustomLauncher(handleToggle)}
                    handleNewUserMessage={handleNewUserMessage}
                />
            </div>
        </div >
    );
}

